import { useQuery } from '@tanstack/react-query';
import { useSelector } from 'react-redux';

import service from 'services/authService';

import { getIsLoggedIn } from 'store/session/selectors';

export default function useGetActiveUserGroupMember() {
  const isLoggedIn = useSelector(getIsLoggedIn);

  return useQuery({
    queryKey: ['activeUserGroupMembers'],
    queryFn: () => service.getActiveUserGroupMembers(),
    enabled: isLoggedIn,
  });
}
